import { RootState } from "../rootState";
import { connect } from "react-redux";

import { Changes, ChangesDispatchProps, ChangesStateProps } from "./Changes";

import { changesEnabledSelector, workspaceModeSelector } from "../common/selector/configurationSelector";
import { validFromSelector } from "../common/selector/validityIntervalSelector";
import { isCesium } from "../../MapStore2/web/client/selectors/maptype";

import { updateChangesTypesAction } from "./redux/changeType";
import { setChangesGeneratedDateAction, updateViewTypeAction } from "./redux/changeWorkspace";
import { updateValidFromAction } from "../portal/action/updateValidityIntervalAction";
import moment from "moment";
import { CONTEXT_WORKSPACE, WORKSPACE_VIEW } from "./changesConstants";
import { loadSlotChangesActionCreator } from "../api/api-packages";
import { changesLoadingAction } from "./redux/changesLoad/changesLoading.action";
import { changesLoadedAction } from "./redux/changesLoad/changesLoaded.action";

const mapStateToProps = (state: RootState): ChangesStateProps => {
    const defaultProps = {
        viewType: WORKSPACE_VIEW,
        context: CONTEXT_WORKSPACE,
        effectiveDate: "Not defined",
    };
    if (!(workspaceModeSelector(state) === false)) {
        return {
            ...defaultProps,
            enabled: false,
        };
    }
    return {
        ...defaultProps,
        enabled: changesEnabledSelector(state),
        displayLoading:
            state.layerLoad.loading ||
            state.wfs3dLayers?.loading ||
            state.wms3dLayers?.loading ||
            state.changes.changesLoad?.loading,
        context: state.changes.workspaceChanges?.context,
        viewType: state.changes.workspaceChanges?.view,
        selectedChangeTypes: state.changes.changeType?.changeType,
        effectiveDate: validFromSelector(state),
        generated: state.changes.workspaceChanges?.dateOfGeneration,
        workspaceName: state.urlParams.slots.haveSlotIds() ? state.urlParams.workspaceName : "",
        changeTypeColoring: state.changes.changeTypeColoring && state.changes.changeTypeColoring.changeToColorMapping,
        isCesium: isCesium(state),
        ticket: state.session?.ticket,
        axiosInitialized: state.axiosState.initialized,
        slotsIds: state.urlParams.slots.getSlotIds(),
    };
};

const mapDispatchToProps = (dispatch: any): ChangesDispatchProps => {
    return {
        handleViewTypeChanged: (viewType: string) => dispatch(updateViewTypeAction(viewType)),
        handleChangesTypeChanged: (changeType: string, value: boolean) =>
            dispatch(updateChangesTypesAction(changeType, value)),
        handleOnClickReloadChanges: (slots: string[] | string, forceReload: boolean) =>
            dispatch(loadSlotChangesActionCreator({ slotIds: slots, forceReload: forceReload })),
        handleEffectiveDateChanged: (validFrom: string) => dispatch(updateValidFromAction(validFrom)),
        handleSetChangesGeneratedDateAction: (date: string) =>
            dispatch(setChangesGeneratedDateAction(moment(date).utc().format("YYYY-MM-DD HH:mm:ss"))),
        handleChangesLoading: () => dispatch(changesLoadingAction()),
        handleChangesLoaded: () => dispatch(changesLoadedAction()),
    };
};

export const ConnectedChanges = connect(mapStateToProps, mapDispatchToProps)(Changes);
